import { styled } from '@mui/material/styles';
import type { AccentColor } from '../AccentCard';

/** White-on-gradient banner running from the accent's light to main shade; body2 text is slightly dimmed. */
export const GradientBanner = styled('div', {
  shouldForwardProp: prop => prop !== 'accent',
})<{ accent: AccentColor }>(({ theme, accent }) => ({
  background: `linear-gradient(90deg, ${theme.palette[accent].light} 0%, ${theme.palette[accent].main} 100%)`,
  color: theme.palette.common.white,
  '& .MuiTypography-body2': { opacity: 0.95 },
}));
